module.exports = __webpack_public_path__ + "media/rubber_3.b0e6f641.mp3";